module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', [_c('b-select', {
    attrs: {
      "placeholder": "Small",
      "size": "is-small",
      "expanded": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "flint"
    }
  }, [_vm._v("Flint")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "silver"
    }
  }, [_vm._v("Silver")])])], 1), _vm._v(" "), _c('b-field', [_c('b-select', {
    attrs: {
      "placeholder": "Default",
      "expanded": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "flint"
    }
  }, [_vm._v("Flint")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "silver"
    }
  }, [_vm._v("Silver")])])], 1), _vm._v(" "), _c('b-field', [_c('b-select', {
    attrs: {
      "placeholder": "Medium",
      "size": "is-medium",
      "expanded": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "flint"
    }
  }, [_vm._v("Flint")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "silver"
    }
  }, [_vm._v("Silver")])])], 1), _vm._v(" "), _c('b-field', [_c('b-select', {
    attrs: {
      "placeholder": "Large",
      "size": "is-large",
      "expanded": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "flint"
    }
  }, [_vm._v("Flint")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "silver"
    }
  }, [_vm._v("Silver")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89c07fec"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/select/examples/ExSizes.vue
// module id = 1171
// module chunks = 29 196